"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Item = _interopRequireDefault(require("./Item"));

var View = function View(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Item["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl font-bold truncate"
  }, children));
};

View.displayName = 'Header';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map